import React from "react";

const Body = ({ renderField, renderCheckbox, renderSelect, ...props }) => {
    const {
        firstName,
        lastName,
        patronymic,
        phoneNumber,
        inn,
        comment,
        needsShiftChangeComment,
        needsUrgentShiftChange,
        transportColumnId,
        accessPermitIds,
    } = props;
    return (
        <>
            {renderField(lastName)}
            {renderField(firstName)}
            {renderField(patronymic)}
            {renderField({ ...phoneNumber, type: "phone" })}
            {renderField(inn)}
            {renderSelect(transportColumnId)}
            {renderField(comment)}
            {renderField(needsShiftChangeComment)}
            {renderCheckbox(needsUrgentShiftChange)}
            {renderSelect(accessPermitIds)}
        </>
    );
};

export default Body;
